// extracted by mini-css-extract-plugin
export var ctaResponsive = "cta_responsive-module--ctaResponsive--ZmgXa";
export var ctaWrapper = "cta_responsive-module--ctaWrapper--e0p+g";
export var isCentered = "cta_responsive-module--isCentered--9ezO9";